module.exports = __webpack_public_path__ + "img/whatsapp-32.d13ecdbf.svg";